import { classes as rootClass } from '../../ApprovalForms/Questions/styles';

export const classes = { ...rootClass };
